import { BitrixVue } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';
import { basketEvents } from '../../services/analytics/analytics';
import { number_format, num_word } from '../../tools/functions';
import { closeHeaderCatalog, clearHeaderMenuDropdown, clearSearch } from '../../tools/functions';

export const HeaderBasket = {
    computed: {
        ...mapState(vplSiteStore, ['basket', 'SITE_TEMPLATE_PATH'])
    },
    methods: {
        number_format: number_format,
        num_word: num_word,
        closeCart(e){

        },
        deleteFromBasket: function(basketId){
            $.ajax({
                url: '/ajax/basket.php',
                method: 'POST',
                data: {action: 'delete', id: basketId},
                success: function(response){
                    try {
                        const basketData = JSON.parse(response);
                        basketEvents(basketData);
                        const store = vplSiteStore();
                        store.basket = basketData;

                        if(!Object.keys(store.basket.ITEMS).length){
                          clearHeaderMenuDropdown();

                        }
                    }catch(err){ }
                }
            });
        },
        dropdownCart() {
            let dropdownCart = document.querySelector(".js-basket-dropdown"),
                cartItems = (dropdownCart !== null ? dropdownCart.querySelectorAll(".js-basket-item") : false),
                cartHeight = 0;

            if (cartItems !== false && cartItems.length > 3) {
              var paddingTop = getComputedStyle(dropdownCart.querySelector(".js-custom-scroll"), null).getPropertyValue("padding-top"),
                  paddingBottom = getComputedStyle(dropdownCart.querySelector(".js-custom-scroll"), null).getPropertyValue("padding-bottom");

              for (var i = 0; i <= cartItems.length; i++) {
                if (i === 3) {
                  dropdownCart.querySelector(".js-custom-scroll").style.height = cartHeight - 1 + +paddingTop.replace("px", "") + +paddingBottom.replace("px", "") + "px";
                  $(".js-custom-scroll").mCustomScrollbar();
                  break;
                }

                cartHeight += cartItems[i].offsetHeight;
              }
            }
        },
        linkMouseEnter(link){
            if ($(window).width() > 991) {
              link = $(link);

              closeHeaderCatalog();
              $('.js-catalog').removeClass('is-active');
              $('.js-header').find('.js-catalog-dropdown').removeClass('is-open');

              if (!link.hasClass('is-open') && link.closest('.js-header-action-item').hasClass('has-child')) {
                link.addClass('is-open');
                link.closest('.js-header-action-item').find('.js-header-action-item-link-dropdown').addClass('is-show');


              }

            }
        },
        linkMouseLeave(){
            if ($(window).width() > 991) {
                clearHeaderMenuDropdown();
            }
        },
        dropdownMouseEnter(dropdown){
            if ($(window).width() > 991) {
                $(dropdown).parent('.js-header-action-item').find('.js-header-action-item-link').addClass('is-open');
                $(dropdown).addClass('is-show');


            }
        },
        dropdownMouseLeave(){
            if ($(window).width() > 991) {
                clearHeaderMenuDropdown();
            }
        },
        closeOverlay(){
          clearHeaderMenuDropdown();
          clearSearch();
          closeHeaderCatalog();
        }
    },
    mounted(){

    },
    updated(){
      if(!(this.basket !== undefined && this.basket !== null && Object.values(this.basket.ITEMS).reduce(function(total, item){return total + (Number(item.QUANTITY) || 0);}, 0))){
        this.closeCart();
      }

      this.dropdownCart();
    },
    template: `
            <div class="header__middle-basket js-header-action-item has-child">

              <a href="/cart/" @click="this.closeCart()" @mouseenter="if(this.basket !== undefined && this.basket !== null && Object.values(this.basket.ITEMS).reduce(function(total, item){return total + (Number(item.QUANTITY) || 0);}, 0)){ this.linkMouseEnter($event.target); }" @mouseleave="this.linkMouseLeave()" class="header__middle-basket-link js-basket js-header-action-item-link">
                <div class="header__middle-basket-link-ico">
                  <div v-if="this.basket !== undefined && this.basket !== null && Object.values(this.basket.ITEMS).reduce(function(total, item){return total + (Number(item.QUANTITY) || 0);}, 0)" class="header__middle-basket-link-amount">
                    {{ (this.basket !== undefined && this.basket !== null ? Object.values(this.basket.ITEMS).reduce(function(total, item){return total + (Number(item.QUANTITY) || 0);}, 0) : '0') }}
                  </div>
                  <svg class="icon icon-basket"><use xlink:href="#icon-basket"></use></svg>
                </div>
                <span>Корзина</span>
              </a>

              <div
                    v-if="this.basket !== undefined && this.basket !== null && Object.values(this.basket.ITEMS).reduce(function(total, item){return total + (Number(item.QUANTITY) || 0);}, 0)"
                    class="header__middle-basket-dropdown js-header-action-item-link-dropdown js-basket-dropdown"
                    @mouseenter="this.dropdownMouseEnter($event.target)"
                    @mouseleave="this.dropdownMouseLeave()"
              >
                <div class="container">
                  <div class="basket-dropdown">
                    <div class="basket-dropdown__list js-custom-scroll">


                      <div v-for="item in this.basket.ITEMS" class="basket-dropdown__list-item js-basket-item" :key="item.ID">
                        <a :href="item.DETAIL_PAGE_URL" @click="this.closeCart()" target="_blank" class="basket-dropdown__list-item-img"  :class="(item.PICTURE !== false ? '' : 'no-photo')">
                          <img v-if="item.PICTURE !== false" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.PICTURE" :alt="item.NAME" :title="item.NAME">
                          <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="item.NAME" :title="item.NAME">
                        </a>
                        <div class="basket-dropdown__list-item-desc">
                          <a :href="item.DETAIL_PAGE_URL" @click="this.closeCart()" target="_blank" class="basket-dropdown__list-item-name">
                              {{ item.NAME }}
                          </a>
                          <!--
                          <div class="basket-dropdown__list-item-serv">
                            <span>Дополнительные услуги</span>
                            <div class="basket-dropdown__list-item-serv-list">
                              <div class="basket-dropdown__list-item-serv-list-item">
                                Монтаж
                              </div>
                              <div class="basket-dropdown__list-item-serv-list-item">
                                Сервисное обслуживание
                              </div>
                            </div>
                          </div>
                          -->

                          <div class="basket-dropdown__list-item-bottom">
                            <div class="basket-dropdown__list-item-amount">{{ item.QUANTITY }} {{ item.MEASURE }}</div>
                            <div class="product-card__price">
                              {{ this.number_format(item.PRICE, 0, '.', ' ') }} ₽/{{ item.MEASURE }}
                              <div v-if="item.BASE_PRICE && item.BASE_PRICE > item.PRICE" class="product-card__price-old">
                                <span>{{ this.number_format(item.BASE_PRICE, 0, '.', ' ') }} ₽ </span>
                                <div class="product-card__price-discount" v-if="item.PERCENT">{{ item.PERCENT }}%</div>
                              </div>
                            </div>
                          </div>
                          <a href="#" class="basket-dropdown__list-item-close" @click.prevent="this.deleteFromBasket(item.ID)">
                            <svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg>
                          </a>
                        </div>
                      </div>


                    </div>
                    <div class="basket-dropdown__bottom">
                      <div class="basket-dropdown__info">
                        <div class="basket-dropdown__info-item">{{ Object.values(this.basket.ITEMS).reduce(function(total, item){return total + (Number(item.QUANTITY) || 0);}, 0) }} {{ this.num_word(Object.values(this.basket.ITEMS).reduce(function(total, item){return total + (Number(item.QUANTITY) || 0);}, 0), ['товар', 'товара', 'товаров']) }}</div>
                        <div class="basket-dropdown__info-item">{{ this.number_format(this.basket.PRICE, 0, '.', ' ') }} ₽</div>
                      </div>
                      <a href="/cart/" @click="this.closeCart()" class="basket-dropdown__btn">Перейти в корзину</a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="header__search-overlay js-header-search-overlay" @click=closeOverlay()></div>

            </div>
    `
}
